
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useUserAdmin } from "../../../admin/UserContext";
import { Container, Typography, Box, CircularProgress} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EmailIcon from "@mui/icons-material/Email";


export const Correo = () => {
    const [loading, setLoading] = useState(false);
    const [correo, setCorreo] = useState([]);
    const { Token } = useUserAdmin();
    const backendURL = process.env.REACT_APP_BACKEND_URL;

     const fetchVista = useCallback(async () => {
        setLoading(true)
          try {
            const response = await axios.get(`${backendURL}/api/reporte/correo`, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            });
            setCorreo(response.data.data);
             setLoading(false)
          } catch (error) {
            console.error("Error al obtener sliders:", error);
          }
        }, [Token, backendURL]);
      
        // Llamada inicial a sliders cuando hay token
        useEffect(() => {
         
           fetchVista();
          
        }, [fetchVista]);


   



    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 70
        },
        {
            field: "nombre",
            headerName: "Nombre",
            flex: 1,
            minWidth: 150
        },
        {
            field: "empresa",
            headerName: "Empresa",
            flex: 1,
            minWidth: 120
        },
        {
            field: "correo",
            headerName: "Correo electrónico",
            flex: 1.5,
            minWidth: 200
        },
        {
            field: "telefono",
            headerName: "Teléfono",
            flex: 1,
            minWidth: 130
        },
        {
            field: "enviado_en",
            headerName: "F echa y hora",
            flex: 1.2,
            minWidth: 160,

        }
    ];


    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress size={80} thickness={6} />
            </Box>
        );
    }
    return (
        <Container sx={{ mt: 4 }}>
            <Box display="flex" alignItems="center" mb={2}>
                <EmailIcon sx={{ color: "#00A69E", fontSize: 36, mr: 1 }} />
                <Typography variant="h5" sx={{ color: "#00A69E", fontWeight: "bold" }}>
                    Correos Recibidos
                </Typography>
            </Box>

            <Box sx={{ height: 600, width: '100%', backgroundColor: '#fff', boxShadow: 3, borderRadius: 2 }}>
                <DataGrid
                    rows={correo}
                    columns={columns}
                    pageSize={8}
                    rowsPerPageOptions={[8, 20, 50]}
                    disableSelectionOnClick
                    getRowId={(row) => row.id}
                    sx={{
                        backgroundColor: "#f0f0f0",
                        color: "#585857",
                        borderColor: "#585857",
                        '& .MuiDataGrid-cell': {
                            color: '#585857',
                            borderColor: '#585857',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            color: '#585857',
                            borderColor: '#585857',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            color: '#585857',
                            borderTop: '1px solid #585857',
                        },
                        '& .MuiSvgIcon-root': {
                            color: '#585857',
                        },
                        '& .MuiCheckbox-root': {
                            color: '#585857',
                        },
                        '& .MuiDataGrid-columnSeparator': {
                            color: '#585857',
                        },
                    }}
                />
            </Box>
        </Container>
    );
};